import React from 'react';

// Sürüm notları verileri
const releaseNotesData = [
    {
        version: "v1.2.0",
        date: "24 Ağustos 2024",
        notes: [
            "Ankara tarihi mekanlar için yeni rotalar eklendi.",
            "Fotoğraf yükleme sayfasında kullanıcı arayüzü iyileştirmeleri yapıldı.",
            "Gizlilik Politikası ve Kullanım Koşulları sayfaları güncellendi."
        ]
    },
    {
        version: "v1.1.5",
        date: "10 Ağustos 2024",
        notes: [
            "Mobil cihazlarda daha iyi bir deneyim için duyarlı tasarım iyileştirmeleri yapıldı.",
            "Görsel galeri bileşenindeki navigasyon hataları giderildi.",
            "Performans iyileştirmeleri ve sunucu optimizasyonları yapıldı."
        ]
    },
    {
        version: "v1.1.0",
        date: "01 Ağustos 2024",
        notes: [
            "Sıkça Sorulan Sorular (FAQ) sayfası eklendi.",
            "Kullanıcı giriş ve kayıt sayfalarında küçük tasarım dokunuşları yapıldı.",
            "Arka plan renk geçişlerinde animasyon iyileştirmeleri yapıldı."
        ]
    },
    {
        version: "v1.0.0",
        date: "15 Temmuz 2024",
        notes: [
            "Uygulamanın ilk kararlı sürümü yayınlandı.",
            "Yapay zeka ile tarihi mekan tanıma özelliği aktif hale getirildi.",
            "Kullanıcı profil sayfaları ve temel navigasyon yapısı oluşturuldu."
        ]
    }
];

const ReleaseNotesPage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Sayfa Başlığı */}
                <header className="text-center mb-12 md:mb-16">
                    <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 mb-4 drop-shadow-md">
                        Sürüm Notları
                    </h1>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                        Mekânname'deki en son güncellemeleri ve iyileştirmeleri buradan takip edebilirsiniz.
                    </p>
                </header>

                {/* Sürüm Notları Listesi */}
                <main className="space-y-8">
                    {releaseNotesData.map((release, index) => (
                        <div
                            key={index}
                            className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-8 shadow-xl border border-gray-700 transition-all duration-300 hover:border-indigo-600"
                        >
                            {/* Sürüm Başlığı ve Tarih */}
                            <div className="flex justify-between items-center mb-4 border-b border-gray-700 pb-2">
                                <h2 className="text-2xl font-bold text-indigo-400">
                                    Sürüm {release.version}
                                </h2>
                                <span className="text-sm text-gray-400 font-medium">
                                    {release.date}
                                </span>
                            </div>
                            
                            {/* Notlar */}
                            <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                                {release.notes.map((note, noteIndex) => (
                                    <li key={noteIndex}>
                                        <p>{note}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </main>
            </div>
        </div>
    );
};

export default ReleaseNotesPage;
